import {ActivatedRouteSnapshot, CanActivateFn, GuardResult, MaybeAsync, RouterStateSnapshot} from "@angular/router";
import {inject} from "@angular/core";
import {authStore} from "../service/auth/auth.store";

export const employeeGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> => {
    return inject(authStore).hasAuthority('EMPLOYEE')();
}